var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.customCol),function(d){return _c('vxe-column',{key:d.key,attrs:{"sortable":"","filters":[{ data: '' }],"filter-method":_vm.$$filterHeaderTable,"width":"150","align":"center","field":d.key,"title":d.title,"formatter":d.format == 'number'
        ? _vm.$$formatNumber
        : d.format == 'price'
        ? _vm.$$formatAmountBc
        : d.format == 'date'
        ? _vm.$$formatDate
        : d.format == 'datetime'
        ? _vm.$$formatDatetimemoment
        : ''}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }